<aside
  caSidebar
  #sidebar="ca-sidebar"></aside>

<div
  class="routed-content"
  [class.routed-content_expanded]="sidebar.isCollapsed()"
>
  <div class="container">
    <router-outlet/>
  </div>
</div>
